import React, { Suspense, lazy } from 'react';
import { Placement } from '@atlassian/post-office-placement-remote';
import { ErrorBoundary, useFeatureToggle } from '@css-xp/base';
import { useApplicationContext } from '@css-xp/base/common-context';
import { IntlProvider } from 'react-intl-next';
import { ENABLE_POST_OFFICE_NOTIFICATIONS } from '@css-xp/ppc-constants';
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
const NotificationsWithIntl = lazy(() => import('xp_notifications/NotificationsWithIntl'));
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
const UserContextProvider = lazy(() => import('xp_notifications/UserContextProvider'));

export const NotificationComponent = () => {
  const userProfile = useApplicationContext();
  const [isEnabled] = useFeatureToggle();
  const isPostOfficeNotificationEnabled = isEnabled(ENABLE_POST_OFFICE_NOTIFICATIONS);

  if (isPostOfficeNotificationEnabled) {
    return (
      <ErrorBoundary subject="notifications-test-boundary">
        <Suspense fallback={<></>}>
          <IntlProvider locale="en">
            <UserContextProvider value={{ atlassianAccountId: userProfile.atlassianAccountId }}>
              <div>
                <Placement placementId="admin-hub-notifications" />
              </div>
            </UserContextProvider>
          </IntlProvider>
        </Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary subject="notifications-test-boundary">
      <Suspense fallback={<></>}>
        {/* @ts-ignore */}
        <UserContextProvider value={{ atlassianAccountId: userProfile.atlassianAccountId }}>
          <NotificationsWithIntl />
        </UserContextProvider>
      </Suspense>
    </ErrorBoundary>
  );
};
